import React, { useState, useEffect } from "react";
import { FaMobileAlt, FaKey, FaCheckCircle } from "react-icons/fa";
import ReactTelInput from "react-telephone-input";
import Axios from "axios";
import { BASE_URL, HOST_URL } from "../Dashboard/api/Api";
import "react-telephone-input/css/default.css"; // Make sure this is imported
import flags from "../Dashboard/assets/img/flags.png";

const MobileVerification = ({ jwt, method }) => {
  const jwtToken = jwt;
  const methodLogin = method

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [countryCode, setCountryCode] = useState("91"); // default dial code for 'in'
  const [defaultCountry, setDefaultCountry] = useState("in");
  const [timer, setTimer] = useState(120); // 2 minutes = 120 seconds
  const [canResend, setCanResend] = useState(false);

  const [redirectAfterLogin, setRedirectAfterLogin] = useState(null);

  const handleInputChange = (telNumber, selectedCountry) => {
    setCountryCode(selectedCountry.dialCode); // e.g., '91'
    setDefaultCountry(selectedCountry.iso2);
  };

  const handleUserInput = (e) => {
    const { name, value } = e.target;
    if (name === "mobile") setMobile(value);
    if (name === "otp") setOtp(value);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      setRedirectAfterLogin(ref);
    }
  }, []);

  useEffect(() => {
    let interval;
    if (step === 2 && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer, step]);


  const handleNext = () => {
    if (step < 3) {
      setStep(step + 1);
    }
  };

  const sendOtp = async (event) => {
    event.preventDefault();
    try {
      const { data } = await Axios.post(`${HOST_URL}/login_socialmedia.php`, {
        method: methodLogin === "link_login" ? "send_otp" : methodLogin,
        jwt_token: jwtToken,
        mobile: mobile,
        country_code: countryCode,
      });
      if (data?.success) {
        setStep(2);
        setTimer(120);       // Reset timer
        setCanResend(false); // Disable resend initially
      } else {
        alert(data?.message || "Failed to send OTP");
      }
    }

    catch (error) {
      console.error("Send OTP error:", error);
      alert("Failed to send OTP. Please try again.");
    }
  }

  const verifyOtp = async (event) => {
    event.preventDefault();
    try {
      const { data } = await Axios.post(`${HOST_URL}/login_socialmedia.php`, {
        // method: methodLogin,
        method: methodLogin === "link_login" ? "send_otp" : methodLogin,
        jwt_token: jwtToken,
        mobile: mobile,
        country_code: countryCode,
        otp: otp,
      });

      if (data?.success) {
        setStep(3);
        localStorage.setItem("login", JSON.stringify(data));
        localStorage.setItem("admin", JSON.stringify({ success: false }));
        setTimeout(() => {
          if (redirectAfterLogin) {

            if (redirectAfterLogin === "/dashboard/whatsapp-onboarding-new") {
              window.open(redirectAfterLogin, "_blank");
            } else {
              window.location.href = redirectAfterLogin;
            }
          } else {
            window.location.href = "/dashboard";
          }
        }, 1000);

        console.log(data);
      } else {
        alert(data?.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Verify OTP error:", error);
      alert("OTP verification failed. Please try again.");
    }

  };

  const pageStyle = {
    backgroundColor: "#f0f8ff",
    minHeight: "100vh",
    padding: "40px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "30px 20px",
    width: "340px",
    height: "460px",
    textAlign: "center",
    margin: "20px auto",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  };

  const titleStyle = {
    fontWeight: "bold",
    fontSize: "20px",
    margin: "15px 0 5px 0",
    color: "#000",
  };

  const subtitleStyle = {
    fontSize: "12px",
    color: "#555",
    marginBottom: "15px",
  };

  const inputWrapperStyle = {
    display: "flex",
    alignItems: "center",
    marginTop: "15px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "8px 12px",
    backgroundColor: "#f9f9f9",
  };

  const inputStyle = {
    border: "none",
    outline: "none",
    fontSize: "14px",
    width: "100%",
    background: "transparent",
    marginLeft: "10px",
  };

  const buttonStyle = {
    marginTop: "20px",
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    fontWeight: "bold",
    cursor: "pointer",
  };

  const iconStyle = {
    fontSize: "50px",
    color: "#000000",
    marginBottom: "15px",
    alignSelf: "center",
  };

  return (
    <>

      <div style={{
        position: "fixed", top: 0, left: 0,
        width: "100%", height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000,
        padding: "20px",
        borderRadius: "8px", minWidth: "300px", textAlign: "center"
      }}>
        <div>
          <div style={cardStyle}>
            {step === 1 && (
              <>
                <FaMobileAlt style={iconStyle} />
                <h2 style={titleStyle}>Enter your Mobile Number</h2>
                <p style={subtitleStyle}>
                  Please enter your mobile number to receive a 6-digit verification code.
                </p>
                <div style={inputWrapperStyle}>
                  <div className="input-group">
                    <div className="input-group-prepend ReactTelFullbox">
                      <ReactTelInput
                        defaultCountry={defaultCountry}
                        flagsImagePath={flags}
                        onChange={handleInputChange}
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control logininput"
                      placeholder="Enter Mobile Number"
                      name="mobile"
                      value={mobile}
                      onChange={handleUserInput}
                    />
                  </div>
                </div>
                <button style={buttonStyle} onClick={sendOtp}>
                  Send OTP
                </button>
              </>
            )}

            {step === 2 && (
              <>
                <FaKey style={iconStyle} />
                <h2 style={titleStyle}>Enter Verification Code</h2>
                <p style={subtitleStyle}>
                  Please enter the 6-digit code sent to your mobile number.Check your WhatsApp or SMS for OTP.
                </p>
                <div style={inputWrapperStyle}>
                  <input
                    type="text"
                    name="otp"
                    value={otp}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/, "");
                      if (value.length <= 6) {
                        handleUserInput({ target: { name: "otp", value } });
                      }
                    }}
                    placeholder="Enter 6-digit OTP"
                    style={inputStyle}
                    maxLength="6"
                  />
                </div>
                <button style={buttonStyle} onClick={verifyOtp}>
                  Verify
                </button>
                <p style={{ fontSize: "12px", marginTop: "10px", color: "#777" }}>
                  {canResend
                    ? "Didn't receive the code?"
                    : `Resend OTP in ${Math.floor(timer / 60)}:${(timer % 60)
                      .toString()
                      .padStart(2, "0")}`}
                </p>

                {canResend && (
                  <button
                    style={{ ...buttonStyle, backgroundColor: "#28a745" }}
                    onClick={sendOtp}
                  >
                    Resend OTP
                  </button>
                )}
                <div>
                </div>
              </>
            )}

            {step === 3 && (
              <>
                <FaCheckCircle className="text-success" style={iconStyle} />
                <h2 style={titleStyle}>Successfully</h2>
                <p style={subtitleStyle}>Your mobile number has been successfully verified.</p>
              </>
            )}
          </div>
        </div>
      </div>

    </>
  );
};

export default MobileVerification;
